import { type ReactElement } from 'react';

/**
 * Static-export HTML entry. nginx / edge send non-asset URLs to this page's
 * exported HTML on first load.
 *
 * App routing is RR7 in `_app` (see mount sequence there). Next's client-router
 * hand-off on refresh also runs in `_app` via `bootstrapNextRouterFromStaticSiteEntry`.
 * This component is intentionally empty.
 */
export function StaticSiteRouter(): ReactElement {
  return <></>;
}

export default StaticSiteRouter;
